//Librerias
import * as THREE from "three";
//Proyecto
import Maqueta from "../../../Maqueta.js";

export default class Materiales {
  constructor() {
    this.maqueta = new Maqueta();
    this.escena = this.maqueta.escena;
    this.colores = this.maqueta.colores;
    this.recursos = this.maqueta.recursos;
    this.debug = this.maqueta.debug;

    this.materialesProyecto = {};
    this.materialesContexto = {};
    this.materialesPersonas = [];
    this.materialesArbustos = [];
    this.materialesArboles = [];
    this.materialesArbolesRelleno = [];

    this.recursos.on("cargado", () => {
      this.crearMateriales();
    });

    //Debug
    if (this.debug.active) {
      this.debugMateriales = this.debug.ui.addFolder("Materiales");
    }
  }
  crearMateriales() {
    //******************
    //Materiales proyecto
    //******************

    this.materialesProyecto.text_torreDeshabilitada =
      new THREE.MeshStandardMaterial({
        color: this.colores.coloresMundo.colorEdificios,
        transparent: false,
        //opacity: 0.8,
      });

    //Vecinos
    this.materialesProyecto.edificiosVecinos = new THREE.MeshStandardMaterial({
      color: this.colores.coloresMundo.colorEdificios,
      transparent: true,
      opacity: 0.5,
    });
    
    

    //Vidrio
    

    //Barandas

   
    //Mascaras
    this.materialesProyecto.mascaras = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascara1,
      transparent: true,
      opacity: .5
    })
    this.materialesProyecto.mascarasVendido = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascara2,
      transparent: true,
      opacity: .5
    })
    this.materialesProyecto.mascarasOpcionado = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascara3,
      transparent: true,
      opacity: .5
    })
    this.materialesProyecto.mascaraHover = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascaraHover,
      transparent: true,
      opacity: .5
    })
    this.materialesProyecto.mascaraClick = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascaraClick
    })

    this.materialesProyecto.zonasSeleccionadas = new THREE.MeshStandardMaterial({
      color: this.colores.paleta.color6
    })
    this.materialesProyecto.pisoSeleccionado = new THREE.MeshStandardMaterial({
      color: this.colores.paleta.color6
    })
    this.materialesProyecto.mascarasZonas = new THREE.MeshBasicMaterial({
      color: this.colores.mascaras.mascara3,
      transparent: true,
      opacity: .5,
      side: THREE.DoubleSide
    })

    //******************
    //Materiales contexto
    //******************

    //Nubes

    //Satelital
    const texturaSatelital = this.recursos.items.textura_satelital;
    this.materialesContexto.satelital = new THREE.MeshStandardMaterial({
      map: texturaSatelital,
      side: THREE.DoubleSide,
    });
    
    //Elevacion
    this.materialesContexto.elevacion = new THREE.MeshStandardMaterial({
      displacementMap: this.recursos.items.textura_terreno_elevacion,
      displacementScale: 12,
      color: this.colores.coloresMundo.colorTerreno,
    });

    //Vias
    
    //Arbustos

    //Arboles
    
    //Arboles Relleno

    //Personas   

  }
}
